// extracted by mini-css-extract-plugin
export default {"icon":"ToastCloseIcon_icon__Tyjd7"};